
import { Component, Prop, Vue } from 'vue-property-decorator';
import { WebsiteComposite } from '@/services/Website/interfaces';

@Component
export default class StagingCreatePanel extends Vue {
  @Prop({ type: Object, required: true })
  public composite!: WebsiteComposite;

  @Prop({ type: Boolean, default: false })
  public busy!: boolean;

  @Prop({ type: String, default: '' })
  public errorMessage!: string;

  public environment: 'clone' | 'new' | 'empty' = 'clone';

  public email = '';

  public user = '';

  public password = '';

  public readonly environments: { text: string; value: string }[] = [
    { text: 'Clone', value: 'clone' },
    { text: 'New', value: 'new' },
    { text: 'Empty', value: 'empty' },
  ];

  public get domain(): string {
    return this.composite.website.domain;
  }

  public get valid(): boolean {
    if (this.environment !== 'new') {
      return true;
    }

    return !!this.email.trim() && !!this.user.trim() && !!this.password.trim();
  }

  public onSubmit(): void {
    if (!this.valid) {
      return;
    }

    const payload: { environment: string; email?: string; user?: string; password?: string } = {
      environment: this.environment,
    };

    if (this.environment === 'new') {
      payload.email = this.email.trim();
      payload.user = this.user.trim();
      payload.password = this.password;
    }

    this.$emit('submit', payload);
  }
}
